import { Dialog, DialogContent } from "@mui/material";
import { DialogTitle } from "conference/components/dialogs";
import VideoBackgroundEffectDialogContent from "./Content";
import { FormattedMessage } from "react-intl";

type Props = {
    show: boolean;
    close: () => void;
};

const VideoBackgroundEffectDialog = ({ close, show }: Props) => {
    return (
        <Dialog open={show} onClose={close} maxWidth="lg">
            <DialogTitle>
                <FormattedMessage id="videoBackgroundEffect.title" defaultMessage="Change background" />
            </DialogTitle>
            <DialogContent style={{ padding: "1em" }}>
                <VideoBackgroundEffectDialogContent />
            </DialogContent>
        </Dialog>
    );
};

export default VideoBackgroundEffectDialog;
